var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.228V14a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h6.772A.5.5 0 019 1.555V4a1 1 0 001 1h2.445a.5.5 0 01.055.228zM14 14V5.228a2 2 0 00-.586-1.414L10.186.586A2 2 0 008.772 0H2a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2zM2.4 11.708a.7.7 0 01.7-.7h7.3a.8.8 0 01.8.8v.385a.215.215 0 01-.215.215H3.1a.7.7 0 01-.7-.7zm.7-4.604a.7.7 0 100 1.4h7.885a.215.215 0 00.215-.215v-.385a.8.8 0 00-.8-.8H3.1zM2.4 3.9a.7.7 0 01.7-.7h3.365c.225 0 .407.182.407.406v.885a.11.11 0 01-.11.109H3.1a.7.7 0 01-.7-.7z",
    fill: "#6F6F6F"
  })));
}
export default SvgIconFile;